/* istanbul ignore file */
import React, { Fragment, useEffect, useState } from 'react'
import Paragraph from './Paragraph';
import Image from './Image';
import Line from './Line';
import BarcodeGenerator from './BarCode';
import InputField from './InputField';
import TextArea from './TextArea';
import Radio from './Radio';
import SelectBox from './SelectBox';
import CheckBox from './CheckBox';
import MainSignature from './MainSignature';
import { dataService } from '../../../../../services/data.service';

export default function TemplateComponent({component, view, pageIndex, formData}){
    const [templateComponents, setTemplateComponents] = useState([]);
    const [componentsLoading, setComponenentsLoading] = useState(component.component_id);
    const [versionData, setVersionData] = useState('');

    const handleGetComponents = () => {
        dataService.GetTemplateComponents(component.template_id, component.template_version_id, component.component_id, 'all', formData.form_id, formData.version_id).then((res) => {
            if(res.error === false) {
                const temp = [{components: res.data.data}];
                setTemplateComponents(temp);
                setComponenentsLoading('');
            }
        })
    }

    useEffect(() => {
        setComponenentsLoading(component.component_id);
        handleGetComponents();
    }, [])
    
    return (
        componentsLoading === component.component_id ?
            <div style={component.styles} className='animate-pulse w-[200px] h-[100px] bg-slate-300' />
            : <div style={component.styles} width={templateComponents[0]?.components[0]?.canvas_width} height={templateComponents[0]?.components[0]?.canvas_height}>
                {!component.is_template_selected ?
                    <div style={component.styles}>
                        <img src="/images/template-placeholder.svg" style={component.styles} className='object-cover' alt="template" />
                    </div>
                    : templateComponents[0]?.components?.map((pComponent, index) => (
                        <Fragment key={`${component.component_id}-${index}`}>
                            <div
                                className={`${(!view || (versionData?.is_published === false)) ? 'dropped-component cursor-pointer ' : 'absolute cursor-default'} 
                                    ${pComponent.type === 'container' ? 'transparent-container' : 'z-[1]'} ${(pComponent.type === 'list') ? 'max-w-[720px]' : ''} ${pComponent.type === 'table' ? 'max-w-[720px]' : ''}`}
                                data-testid="component"
                                style={pComponent.type === 'container' ?  {...pComponent?.styles, left: pComponent.x , top: pComponent.y} : { width: pComponent.line_type === 'Vertical' ? '' 
                                    : pComponent.width || 'auto', height: pComponent.line_type === 'Vertical' ? pComponent.width : pComponent.type === 'paragraph' ? pComponent.height : ''  || 'auto', left: pComponent.x , top: pComponent.y }}
                                data-componentid={pComponent?.component_id}
                                id={`main-${pComponent?.component_id}`}
                            >
                                <div
                                    style={(pComponent.type === 'line' || pComponent.type === 'paragraph') ? {height: '-webkit-fill-available', width: '-webkit-fill-available'} : {}}
                                    className={`${pComponent.type === 'line' ? 'p-[10px]' : ''}`}>
                                    {pComponent?.type === 'input' && <InputField view={view} versionData={versionData} component={pComponent} />}
                                    {pComponent?.type === 'textarea' && <TextArea view={view} versionData={versionData} component={pComponent} />}
                                    {pComponent?.type === 'paragraph' && <Paragraph view={view} versionData={versionData} component={pComponent} />}
                                    {pComponent?.type === 'radio' && <Radio component={pComponent} view={view} versionData={versionData} />}
                                    {/* {pComponent?.type === 'table' && <Table component={pComponent} />} */}
                                    {pComponent?.type === 'image' && <Image view={view} versionData={versionData} component={pComponent} />}
                                    {pComponent?.type === 'container' && 
                                    <div className={`w-[100px] h-[100px] cursor-default`} data-page-number={pageIndex} style={{
                                        width: pComponent?.styles?.width,
                                        height: pComponent?.styles?.height
                                    }} data-testid="container" id={pComponent.component_idid} />}
                                    {pComponent?.type === 'select-box' && <SelectBox component={pComponent} view={view} versionData={versionData} />}
                                    {pComponent?.type === 'checkbox' && <CheckBox view={view} versionData={versionData} component={pComponent}/>}
                                    {pComponent?.type === 'line' && <Line component={pComponent} view={view} versionData={versionData} />}
                                    {pComponent.type === 'signature' && <MainSignature versionData={versionData} view={view} formData={formData} component={pComponent} pageIndex={pageIndex} />}
                                    {pComponent?.type === 'barcode' && <BarcodeGenerator component={pComponent} />}
                                </div>
                            </div>
                        </Fragment>
                    ))}
            </div>
    )
}